<script setup>
  defineOptions({ inheritAttrs: false })
  const model = defineModel()
</script>

<template lang="pug">
  CurrencyInput(v-model="model" v-bind="$attrs" :min-digits="0" :max-digits="0" :step="1")
</template>
